<mat-accordion class="stack-accordion" multi>
  <mat-expansion-panel
    class="stack-section"
    [expanded]="todoTodayCount > 0"
  >
    <mat-expansion-panel-header [style.background-color]="headerColor">
      <mat-panel-title>TO DO TODAY ({{ todoTodayCount }})</mat-panel-title>
    </mat-expansion-panel-header>
    <app-stack-todo-today
      (taskCountChange)="todoTodayCount = $event"
      (jobsChanged)="refreshAll()"
    ></app-stack-todo-today>
  </mat-expansion-panel>

  <mat-expansion-panel class="stack-section">
    <mat-expansion-panel-header [style.background-color]="headerColor">
      <mat-panel-title>TO ORDER ({{ toOrderCustomerCount }})</mat-panel-title>
    </mat-expansion-panel-header>
    <app-stack-vendors
      section="orders"
      tableView="orders"
      (countsChange)="onToOrderCounts($event)"
      (jobsChanged)="refreshAll()"
    ></app-stack-vendors>
  </mat-expansion-panel>

  <mat-expansion-panel class="stack-section">
    <mat-expansion-panel-header [style.background-color]="headerColor">
      <mat-panel-title>HOLD / RX ({{ holdCount }})</mat-panel-title>
    </mat-expansion-panel-header>
    <app-stack-vendors
      section="hold"
      tableView="hold"
      (countsChange)="holdCount = $event.total"
      (jobsChanged)="refreshAll()"
    ></app-stack-vendors>
  </mat-expansion-panel>

  <mat-expansion-panel class="stack-section">
    <mat-expansion-panel-header [style.background-color]="headerColor">
      <mat-panel-title>TO REPAIR ({{ toRepairCount }})</mat-panel-title>
    </mat-expansion-panel-header>
    <app-stack-vendors
      section="to-repair"
      tableView="orders"
      (countsChange)="toRepairCount = $event.total"
      (jobsChanged)="refreshAll()"
    ></app-stack-vendors>
  </mat-expansion-panel>

  <mat-expansion-panel class="stack-section">
    <mat-expansion-panel-header [style.background-color]="headerColor">
      <mat-panel-title>AWAITING FRAMES ({{ awaitingFrameCount }})</mat-panel-title>
    </mat-expansion-panel-header>
    <app-stack-vendors
      section="awaiting-frames"
      tableView="awaiting"
      (countsChange)="awaitingFrameCount = $event.total"
      (jobsChanged)="refreshAll()"
    ></app-stack-vendors>
  </mat-expansion-panel>

  <mat-expansion-panel class="stack-section">
    <mat-expansion-panel-header [style.background-color]="headerColor">
      <mat-panel-title>AWAITING LENSES ({{ awaitingLensesCount }})</mat-panel-title>
    </mat-expansion-panel-header>
    <app-stack-vendors
      section="awaiting-lenses"
      tableView="awaiting"
      (countsChange)="awaitingLensesCount = $event.total"
      (jobsChanged)="refreshAll()"
    ></app-stack-vendors>
  </mat-expansion-panel>

  <mat-expansion-panel class="stack-section">
    <mat-expansion-panel-header [style.background-color]="headerColor">
      <mat-panel-title>AWAITING REPAIR ({{ awaitingRepairCount }})</mat-panel-title>
    </mat-expansion-panel-header>
    <app-stack-vendors
      section="awaiting-repair"
      tableView="awaiting"
      (countsChange)="awaitingRepairCount = $event.total"
      (jobsChanged)="refreshAll()"
    ></app-stack-vendors>
  </mat-expansion-panel>

  <mat-expansion-panel class="stack-section">
    <mat-expansion-panel-header [style.background-color]="headerColor">
      <mat-panel-title>HOLD ({{ genericHoldCount }})</mat-panel-title>
    </mat-expansion-panel-header>
    <app-stack-vendors
      section="generic-hold"
      tableView="generic-hold"
      (countsChange)="genericHoldCount = $event.total"
      (jobsChanged)="refreshAll()"
    ></app-stack-vendors>
  </mat-expansion-panel>
</mat-accordion>
